<template>
	<ProgressSpinner v-if="!firmwareType"/>
	<Container class="pt-6" v-if="firmwareType">
		<div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">
			<PageHeading>{{ firmwareType.name ?? $route.params.firmwareType }}</PageHeading>
		</div>

		<div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 -px-8">
			<TabLayout :tabs="tabs" sticky/>
		</div>

		<router-view
				@on-save="$emit('on-save')"
				@on-delete="$emit('on-delete')"
				:firmware-type="firmwareType"
		></router-view>
	</Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import { mapStores } from "pinia";
import { useFirmwareTypesStore } from "@/stores/firmwareTypes.js";
import Container from "@/Components/Container.vue";


export default {
	name: "FirmwareTypeView",
	components: {Container, TabLayout, PageHeading},
	data() {
		return {
			firmwareType: undefined,
		}
	},
	emits: [
		'on-save',
		'on-delete',
	],
	watch: {
		'$route.params.firmwareType': {
			async handler(newValue, oldValue) {
				if(newValue){
					if(this.$route.params.firmwareType === 'NEW'){
						this.firmwareType = {};
					} else {
						this.firmwareType = await this.firmwareTypesStore.showFirmwareType(this.$route.params.firmwareType);
					}
				} else {
					this.firmwareType = undefined;
				}
			},
			immediate: true,
		}
	},
	computed: {
		...mapStores(useFirmwareTypesStore),
		tabs() {
			return [
				{
					label: this.$t('pages.admin.firmware.types.type.firmware_type_view.summary'),
					current: this.$route.name === 'admin.firmware.types.type',
					to: {name: 'admin.firmware.types.type', params: this.$route.params}
				},
				// {
				// 	name: 'Assets',
				// 	current: this.$route.name === 'admin.firmware.firmware.assets',
				// 	to: {name: 'admin.firmware.firmware.assets', params: this.$route.params}
				// },
			]
		}
	},
}
</script>